import { render, staticRenderFns } from "./projectConfigurations.vue?vue&type=template&id=145d9c31&scoped=true&"
import script from "./projectConfigurations.vue?vue&type=script&lang=js&"
export * from "./projectConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./projectConfigurations.vue?vue&type=style&index=0&id=145d9c31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d9c31",
  null
  
)

export default component.exports